import type { SchoolTestApi } from '@mathflat/domain/@entities/(Content)/SchoolTest/api'

import {
  type RecentlyDownloadedSchool,
  type SchoolsBySchoolInfoRequest,
  schoolTestApi,
} from '@/api/schoolTest.api'
import { SchoolTest } from '@/dto/SchoolTest/SchoolTest'

import type Controller from './Controller'

class SchoolTestController implements Controller {
  adapter = {
    from: {
      schoolTestList: (data: Awaited<ReturnType<typeof schoolTestApi.getSchoolTestList>>) => {
        return {
          ...data.data,
          content: data.data.content.map((schoolTest) => new SchoolTest(schoolTest)),
        }
      },
    },
  }

  fetchSchoolTestList = async (
    params: Parameters<typeof schoolTestApi.getSchoolTestList>[0],
    signal?: AbortSignal,
  ) => {
    const data = await schoolTestApi.getSchoolTestList(params, signal)
    return this.adapter.from.schoolTestList(data)
  }

  fetchSchoolTestDownloadInfo = async (
    params: Parameters<typeof schoolTestApi.getSchoolTestDownloadFile>[0],
  ) => {
    const { data } = await schoolTestApi.getSchoolTestDownloadFile(params)
    return data
  }

  fetchSchoolsBySchoolInfo = (params: SchoolsBySchoolInfoRequest, signal?: AbortSignal) => {
    return schoolTestApi.getSchoolsBySchoolInfo(params, signal)
  }
  fetchSchoolTestsGroupBySchool = async (params: SchoolsBySchoolInfoRequest) => {
    return await schoolTestApi.getSchoolTestsGroupBySchool(params)
  }

  fetchMonthlyPdfQuotaStatus = async () => {
    const { data: monthlyPdfQuotaStatus } = await schoolTestApi.getMonthlyPdfQuotaStatus()
    return monthlyPdfQuotaStatus
  }

  createPdfDownloadLog = (payload: SchoolTestApi.Request.PostPdfDownloadLog) => {
    schoolTestApi.postPdfDownloadLog(payload)
  }

  fetchRecentlyDownloadedSchools = async (size: number): Promise<RecentlyDownloadedSchool[]> => {
    const { data } = await schoolTestApi.getRecentlyDownloadedSchools({ size })
    return data.schools
  }
}

export const schoolTestController = new SchoolTestController()
